import { FaCheck } from 'react-icons/fa';

const Checkbox = ({value, setValue}) => {

  console.log(value);

  return (
    <div onClick={() => {setValue(!value);}} className='cursor-pointer w-fit'>
        {
            value ? 
            <div className='border border-blue-500 w-5 h-5 flex justify-center items-center rounded-sm'> 
              <FaCheck className='text-blue-500 w-3 h-3'/>
            </div> : <div className='border w-5 h-5 rounded-sm'> 
            </div>
        }
    </div>
  )
}

export default Checkbox